export default locationStr => locationStr || 'My location';
